import define from '@ingka/webc-tools';
import Button from './src/Button.js';
import ExpandingButton from './src/Expanding.js';
import IconButton from './src/IconButton.js';
export { Button, ExpandingButton, IconButton };
export const buttonTagName = define('button', Button);
export const expandingButtonTagName = define('expanding-button', ExpandingButton);
export const iconButtonTagName = define('icon-button', IconButton);
